<template>
  <v-container>
    <v-dialog
      :value="value"
      @input="$emit('input', $event.target.value)"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card color="primary">
        <v-toolbar color="primary">
          <v-toolbar-title>
            <h3>{{ isEdit ? "Editing ESD Audit" : "New ESD Audit" }}</h3>
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            @click="
              $emit('input', false);
              reset();
            "
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-stepper v-model="currentStep" vertical class="elevation-0" v-if="value">
          <v-stepper-items>
            <v-stepper-step step="1" :complete="currentStep > 1" editable>Choose an Employee</v-stepper-step>
            <v-stepper-content step="1">
              <v-form @submit.prevent="currentStep++">
                <v-card-text>
                  <UserSearch
                    v-if="value"
                    @employee-selected="employeeSelected"
                    :user="
                      isEdit
                        ? {
                            displayName: body.employee.name,
                            employeeID: body.employee.badgeID
                          }
                        : null
                    "
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn flat @click="$emit('input', false);reset();">Cancel</v-btn>

                  <v-btn flat color="secondary lighten-1" type="submit">Continue</v-btn>
                </v-card-actions>
              </v-form>
            </v-stepper-content>

            <v-stepper-step step="2" :complete="currentStep > 2" editable>Complete Audit</v-stepper-step>
            <v-stepper-content step="2">
              <v-form @submit.prevent="createOrEdit()">
                <v-card-text v-if="currentStep > 1">
                  <YesOrNo
                    question="ESD Passed?"
                    @data="answerSelected"
                    :fillAnswer="
                      isEdit ? edit.response : null
                    "
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn flat color="secondary lighten-1" type="submit">Submit</v-btn>
                </v-card-actions>
              </v-form>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { detailedDiff } from "deep-object-diff";
import UserSearch from "@/components/app/UserSearch";
import YesOrNo from "@/components/app/YesOrNo";

export default {
  name: "createESD",

  props: ["value"],

  data() {
    return {
      isEdit: false,
      currentStep: 1,
      body: {
        auditor: {
          name: "",
          badgeID: ""
        },
        employee: {
          name: "",
          badgeID: ""
        },
        response: {
          yes: false,
          no: false,
          comments: ""
        }
      }
    };
  },

  components: {
    UserSearch,
    YesOrNo
  },

  computed: {
    ...mapGetters({
      user: "app/getUser",
      edit: "audits/getEditAudit"
    })
  },

  watch: {
    edit(val) {
      if (val._id) {
        this.isEdit = true;
        this.body = {
          auditor: val.auditor,
          employee: val.employee,
          response: val.response
        };
      }
    }
  },

  methods: {
    createOrEdit() {
      if (!this.confirmValues()) {
        if (!this.isEdit) {
          this.body.auditor = {
            name: this.user.displayName,
            badgeID: this.user.employeeID
          };
          this.$store.dispatch("audits/create", {
            module: "esd",
            body: this.body
          });
        } else {
          this.body.editedBy = this.user.displayName;
          this.body.changed = this.getChanged();
          this.$store.dispatch("audits/update", {
            module: "esd",
            id: this.edit._id,
            body: this.body
          });
        }

        this.$store.dispatch("audits/getAllAudits", {
          rowsPerPage: 10,
          sortBy: "auditDate",
          descending: true,
          page: 1,
          from: null,
          to: null,
          search: null,
          module: "esd"
        });

        this.reset();
      } else {
        this.$store.dispatch("app/setSnackbar", {
          text: this.confirmValues(),
          color: "red"
        });
      }
    },
    reset() {
      this.currentStep = 1;
      this.isEdit = false;
      this.$emit("input", false);
      this.$store.commit("audits/setEditAudit", []);
    },
    answerSelected(e) {
      this.body.response = e.val;
    },
    employeeSelected(e) {
      let name = null;
      let badgeID = null;
      try {
        name = e.split("(")[0].trim();
        badgeID = e.match(/\d+/)[0];
      } catch {
        badgeID = "";
      }
      this.body.employee = {
        name,
        badgeID
      };
    },
    confirmValues() {
      const { employee, response } = this.body;
      let message = null;
      if (employee.name === "" || !employee.name)
        message = "Please select an employee.";
      else if (
        response.no &&
        (response.components === "" || !response.comments)
      )
        message = "Audit failed but no reason left.";
      else if (!response.no && !response.yes)
        message = "Please select an answer.";
      return message;
    },
    getChanged() {
      let { edit, body } = this;
      let newObj = {
        employee: body.employee,
        auditor: body.auditor,
        response: body.response
      };

      let oldObj = {
        employee: edit.employee,
        auditor: edit.auditor,
        response: edit.response
      };

      return detailedDiff(oldObj, newObj);
    }
  }
};
</script>

<style>
</style>
